export const loading = {
  namespaced: true,
  actions: {},
  state: {
    blockUI: 0,
    isAutoUpdate: false,
  },
  mutations: {
    startLoading (state) {
      state.blockUI++
    },
    endLoading (state) {
      state.blockUI--
    },
    forceEndLoading (state) {
      state.blockUI = 0
    },
    startAutoUpdateLoading (state) {
      state.isAutoUpdate = true
    },
    endAutoUpdateLoading (state) {
      state.isAutoUpdate = false
    },
  },
}
